import { GenericListSelect } from './genericListSelect';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

export const BreedTypeSelect = (props) => {
	if (props.species === 'Sheep') {
		return (
			<Row className="inputRow">
				<Col sm={props.cols.lhs}>Breed:</Col>
				<Col sm={props.cols.rhs}>
					<Form.Control
						id="BreedType"
						placeholder="Enter breed..."
						required={props.required}
						onChange={(evt) => props.handleChange(evt)}
						style={props.controlStyle}
						value={props.value}
						{...(props.lock && { disabled: true })}
					/>
				</Col>
			</Row>
		);
	} else {
		const types = [
			'British',
			'Euro',
			'British x Euro',
			'Bos Indicus',
			'British x Bos Indicus',
			'Euro x Bos Indicus',
			'Composite',
			'Dairy',
			'Wagyu/Wagyu X',
			'Mixed',
		];

		return (
			<>
				<GenericListSelect
					id="BreedType"
					label="Breed"
					dataArray={types}
					cols={props.cols}
					controlStyle={props.controlStyle}
					handleChange={(evt) => props.handleChange(evt)}
					value={props.value}
					required={props.required}
					//pattern = {'^\d+$'}	// integer
					pattern={'^[a-zA-Z]+[a-zA-Z0-9_ -]+$'}
					invalidMsg="Select a Breed type!"
					lock={props.lock}
				/>
			</>
		);
	}
};
